import { createAction } from "redux-actions";
import { CREATE_TRANSFER_CORE, FIND_TRANSFER_CORE,CREATE_AUTHORIZED_INTERNAL_TRANSFER,
    CREATE_AUTHORIZED_EXTERNAL_TRANSFER, CREATE_AUTHORIZED_SWITCH_PAYMENT } from "../constants";
import { feathersCreateData } from "../services";
import { serverFindData } from "../services/crud";

export const internalTransferRequest = createAction(CREATE_TRANSFER_CORE, (data) => feathersCreateData('core-server', {
    service: 'TRANSFERS',
    func: 'INTERNAL_TRANSFER',
    data
})())

export const externalTransferRequest = createAction(CREATE_TRANSFER_CORE, (data) => feathersCreateData('core-server', {
    service: 'TRANSFERS',
    func: 'EXTERNAL_TRANSFER',
    data
})())

export const internalTransferAthorizedRequest = createAction(CREATE_AUTHORIZED_INTERNAL_TRANSFER, (data) => feathersCreateData('transactions-control', {
    service: 'TRANSFERS',
    func: 'CREATE_AUTHORIZED_INTERNAL_TRANSFER',
    data
})())

export const externalTransferAthorizedRequest = createAction(CREATE_AUTHORIZED_EXTERNAL_TRANSFER, (data) => feathersCreateData('transactions-control', {
    service: 'TRANSFERS',
    func: 'CREATE_AUTHORIZED_EXTERNAL_TRANSFER',
    data
})())
export const switchPaymentAthorizedRequest = createAction(CREATE_AUTHORIZED_SWITCH_PAYMENT, (data) => feathersCreateData('transactions-control', {
    service: 'TRANSFERS',
    func: 'CREATE_AUTHORIZED_SWITCH_PAYMENT',
    data
})())

export const findTransferCore = createAction(FIND_TRANSFER_CORE, (filter) => serverFindData('transfers-core-company', filter)())